import { PriceIncrement } from '@src/components/Ladder/PriceIncrement';
import { OrderBook } from '@src/components/OrderBook';
import { PriceIncrementWrapper } from '@src/containers/Trading/DeepDive/Aside/styles';
import { EMPTY_ARRAY, type FeeModeEnum, type Security, type SideEnum } from '@talos/kyoko';
import { noop } from 'lodash-es';
import {
  IndividualOrderBookContent,
  IndividualOrderBookHeader,
  IndividualOrderBookWrapper,
  OrderBookWrapper,
} from './styles';

interface IndividualOrderBookProps {
  security: Security;
  marketAccounts: string[];
  priceIncrement?: string;
  hideLastTraded?: boolean;
  showCumQty?: boolean;
  showAllInPrices?: FeeModeEnum | null;
  showFirmLiquidity: boolean;
  onIncrementChange: (index: number, newIncrement: string) => void;
  onCumQtyClick: (showCumQty: boolean) => void;
  onRowClick: (values: { price: string; side: SideEnum; quantity: string }) => void;
}
export const IndividualOrderBook = ({
  security,
  priceIncrement,
  onIncrementChange: handleIncrementChange,
  hideLastTraded,
  marketAccounts,
  showFirmLiquidity,
  showAllInPrices,
  showCumQty,
  onCumQtyClick,
  onRowClick,
}: IndividualOrderBookProps) => {
  return (
    <IndividualOrderBookWrapper background={hideLastTraded ? 'backgroundContentHover' : 'backgroundContent'}>
      <IndividualOrderBookContent data-testid="multileg-order-book">
        <IndividualOrderBookHeader>
          {security.DisplaySymbol}
          <PriceIncrementWrapper>
            <PriceIncrement
              min={security.MinPriceIncrement || '0.01'}
              value={priceIncrement || security.DefaultPriceIncrement}
              onChange={handleIncrementChange}
            />
          </PriceIncrementWrapper>
        </IndividualOrderBookHeader>
        <OrderBookWrapper>
          <OrderBook
            security={security}
            priceIncrement={priceIncrement || security.DefaultPriceIncrement}
            hideLastTraded={hideLastTraded}
            selectedMarkets={EMPTY_ARRAY}
            selectedMarketAccounts={marketAccounts}
            showFirmLiquidity={showFirmLiquidity}
            showAllInPrices={showAllInPrices}
            showCumQty={showCumQty}
            onCumQtyClick={onCumQtyClick}
            onRowClick={onRowClick}
            clickToTradePreviewOrder={undefined}
            onMouseLeaveRow={noop}
          />
        </OrderBookWrapper>
      </IndividualOrderBookContent>
    </IndividualOrderBookWrapper>
  );
};
